// src/config.js
export const THANKYOU_MESSAGE = "Please proceed to the next question!";
export const SET_TIMEOUT = 1000;